import type { UpcomingAlert } from "../../utils/assetDates";
import { formatDate } from "../../utils/assetDates";
import "./NotificationCenter.css";

type Props = {
  alerts: UpcomingAlert[];
  onOpen: (alert: UpcomingAlert) => void;
};

function dueText(days: number) {
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  return `Due in ${days} days`;
}

export default function NotificationCenter({ alerts, onOpen }: Props) {
  return (
    <details className="notification-center">
      <summary className="notification-button" aria-label="Service notifications">
        <span aria-hidden="true">♢</span>
        {alerts.length > 0 && <i>{alerts.length}</i>}
      </summary>
      <div className="notification-popover">
        <header>
          <div>
            <p>EMAIL ALERT WINDOWS</p>
            <h2>Service notifications</h2>
          </div>
          <span>{alerts.length}</span>
        </header>

        <div className="notification-list">
          {alerts.length === 0 ? (
            <div className="notification-empty">
              No service dates fall within the next 14 days.
            </div>
          ) : (
            alerts.slice(0, 8).map((alert) => (
              <button
                type="button"
                key={`${alert.asset.id}-${alert.serviceType}`}
                onClick={() => onOpen(alert)}
              >
                <i className={alert.alertWindow === 7 ? "urgent" : "warning"}>
                  {alert.alertWindow}
                </i>
                <span>
                  <strong>{alert.asset.name}</strong>
                  <small>
                    {alert.asset.clientName} · {alert.serviceLabel}
                  </small>
                  <em>
                    {dueText(alert.daysRemaining)} · {formatDate(alert.serviceDate)}
                  </em>
                </span>
              </button>
            ))
          )}
        </div>
        <footer>
          Email reminders are queued once per 14-day and 7-day window.
        </footer>
      </div>
    </details>
  );
}
